import { Grid, MenuItem, TextField, Typography, Box, Button } from "@mui/material";
import { useSlideInContext } from "../../../../context/SlideInContext";
import { useManageModal } from "../../../Manage/components/ManageModal";
import usePersonStore from "../../../store/personStore";
import usePersonAuthStore, { decodedToken } from "../../../store/personAuthStore";
import { useEffect, useState } from "react";
import useMyLocationSessions from "../components/triageComponents/useMyLocationSessions";
import LoadingButton from "@mui/lab/LoadingButton";
import SelectSearchOption from "../components/triageComponents/SelectSearchOption";
import SelectTriageDate from "../components/triageComponents/SelectTriageDate";
import { SelectTriageCustomField } from "../components";

export default function GetTriage() {
    const { toggleDrawer } = useSlideInContext();
    const { openModal, closeModal } = useManageModal();
    const defaultLocation = usePersonStore(state => state.company.defaultLocation)

    const accessToken = usePersonAuthStore((state) => state.access_token);
    const [formState, setFormState] = useState<{
        sessionDate: string | null;
        searchParam: string | null;
        customfieldId: string | null;
        category: string | null;
    }>({
        sessionDate: null,
        searchParam: null,
        customfieldId: null,
        category: null
    })

    const handleSelectSearchOption = (option: string) => {
        if (option != "launchDate") {
            setFormState((prevState) => ({
                ...prevState, category: "customfield", customfieldId: option
            }))
        } else {
            setFormState((prevState) => ({
                ...prevState, category: option
            }))
        }
    }
    const handleSelectDate = (date: string) => {
        setFormState((prevState) => ({
            ...prevState,
            sessionDate: date
        }))
    }
    const handleSearchCustom = (data: string) => {
        setFormState((prevState) => (
            {
                ...prevState,
                searchParam: data
            }
        ))
    }
    const handleSubmit = async () => {
        const { sessionDate, searchParam, customfieldId, category } = formState

        if (accessToken) {
            openModal({ type: "TRIAGE_GENERATION_INITIALIZED", eventType: "DISABLE_BACKDROP", cancelButtonLabel: "Close" })
            const { pid, lid } = decodedToken(accessToken);
            const response = await fetch(`${window.__env.API_URL}/api/triage/create-search`, {
                method: "POST",
                headers: {
                    Pid: pid,
                    Lid: defaultLocation!.id ?? lid,
                    "Content-Type": "application/json",
                    authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify({
                    sessionDate: sessionDate != null ? new Date(sessionDate as string) : null,
                    searchParam: searchParam,
                    customfieldId: customfieldId,
                    category: category
                }),

            })
            if (response.status === 404) {
                openModal({ type: "TRIAGE_NO_SESSIONS_FOUND" })
            } else if (response.status >= 500) {
                openModal({ type: "GENERAL_ERROR" });
            }
            if (response.ok) {
                const fileId = await response.json()
                closeModal()
                const link = document.createElement('a');
                link.href = `${window.__env.API_URL}/api/file/download/client/triage-reports/${fileId.fileId}`
                link.target = "_blank"
                // TODO: MAKE A LOADING PAGE AND STATE FOR THIS
                // Prevent potential memory leak and cleanup ObjectURL
                // resources that are no longer in use
                const linkHandler = () => {
                    setTimeout(() => {
                        link.removeEventListener('click', linkHandler);
                        document.body.removeChild(link);
                    }, 300);
                }
                link.addEventListener('click', linkHandler);
                document.body.appendChild(link);
                link.click()
                toggleDrawer()
            }
        }
    }
    // useEffect(() => {
    //     console.log(formState)
    // }, [formState])
    return (
        <Grid container spacing={4}
            direction="column"
            alignItems="center"
        >
            <Grid size={12} direction="column" alignItems="center" textAlign="center">
                <Typography>Create a triage report for the students at {defaultLocation?.name}</Typography>
                <Typography>Triage will reflect all completed sessions</Typography>

            </Grid>
            <Grid size={12}>
                <SelectSearchOption onSelect={handleSelectSearchOption} />
            </Grid>
            {formState.category === "launchDate" ?
                <>
                    <SelectTriageDate onSelect={handleSelectDate} />
                    <Grid size={12} direction="column" alignItems="center">
                        <LoadingButton
                            variant="contained"
                            disabled={!formState.sessionDate}
                            onClick={handleSubmit}
                        >Confirm</LoadingButton>
                    </Grid>
                </>
                :
                formState.category === "customfield" ?
                    <>
                        <SelectTriageCustomField onChange={handleSearchCustom} customFieldId={formState.customfieldId} />
                        <Grid size={12} direction="column" alignItems="center">
                            <LoadingButton
                                variant="contained"
                                disabled={!formState.searchParam}
                                onClick={handleSubmit}
                            >Confirm</LoadingButton>
                        </Grid>
                    </>
                    : <></>}
        </Grid>
    )
}